import { applyMiddleware, combineReducers, compose, legacy_createStore } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer, { AuthState, defaultState as defaultAuthState } from './auth/auth.reducer';
import authPageReducer, {
    AuthPageState,
    defaultState as defaultAuthPageState,
} from './authPage/authPage.reducer';
import errorReducer, { ErrorState, defaultState as defaultErrorState } from './error/error.reducer';
import instanceReducer, {
    InstanceState,
    defaultState as defaultInstanceState,
} from './instance/instance.reducer';
import maintenanceReducer, {
    MaintenanceState,
    defaultState as defaultMaintenanceState,
} from './maintenance/maintenance.reducer';
import projectReducer, {
    ProjectState,
    defaultState as defaultProjectState,
} from './project/project.reducer';

const reduxDevTools = (window as any).__REDUX_DEVTOOLS_EXTENSION__;

export interface ApplicationState {
    auth: AuthState;
    authPage: AuthPageState;
    error: ErrorState;
    instance: InstanceState;
    maintenance: MaintenanceState;
    project: ProjectState;
}
export const defaultState: ApplicationState = {
    auth: defaultAuthState,
    authPage: defaultAuthPageState,
    error: defaultErrorState,
    instance: defaultInstanceState,
    maintenance: defaultMaintenanceState,
    project: defaultProjectState,
};

const reducers = combineReducers({
    auth: authReducer,
    authPage: authPageReducer,
    error: errorReducer,
    instance: instanceReducer,
    maintenance: maintenanceReducer,
    project: projectReducer,
});

const enhances = compose(
    applyMiddleware(thunk),
    process.env.NODE_ENV !== 'production' && reduxDevTools ? reduxDevTools() : (f: any) => f
) as any;

export default legacy_createStore(reducers, defaultState, enhances);
